import { cn } from '@forest/shared'
import { native } from '~/services/native'

export function CloseButton(props: { className?: string }) {
  return (
    <button
      className={cn(
        'grid size-9 place-items-center overflow-hidden rounded-full bg-white/65 backdrop-blur-[37.5px]',
        props.className,
      )}
      onClick={() => {
        native.general.close()
        native.general.logEvent({
          event_name: 'component_event',
          event_params: {
            component_name: 'vibe_reader_close_btn',
            app_action: 'click',
            type: 'btn',
          },
        })
      }}
      style={{
        border: '1.5px solid rgba(255, 255, 255, 0.30)',
      }}
    >
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.21429 4.71442L13.7857 13.2858"
          stroke="#333333"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.21427 13.2858L13.7856 4.71442"
          stroke="#333333"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
